import "@fontsource/mulish";
import "@fontsource/mulish/400.css"; // Regular
import "@fontsource/mulish/500.css"; // Medium
import "@fontsource/mulish/600.css"; // Semi-Bold
import "@fontsource/mulish/700.css"; // Bold
import "@fontsource/mulish/800.css"; // Extra-Bold
import "@fontsource/mulish/900.css"; // Extra-Bold
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Header from "./components/Header";
import Homepage from "./pages/index";
import Thankyou from "./pages/thankyou";
import { pageViewEvent } from "./services/adobeDataLayer";

function App() {
  //Trigger AA Page View Event
  useEffect(() => {
    pageViewEvent("landing page");
  }, []);

  return (
    <HelmetProvider>
      <Router basename={window.location.pathname}>
        <Header path="./dist/img/logo.webp" />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/thankyou" element={<Thankyou />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
